// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6178":"0339656c","7710":"383a5eef"}[chunkId] + ".chunk.css";
};